var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_2287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 8.9372C20.1399 8.90305 22.2072 9.71113 23.7565 11.1872L28.0381 6.90658C25.3218 4.35753 21.725 2.95771 18.0003 3.00002C15.2204 2.99951 12.495 3.77191 10.1288 5.23093C7.76253 6.68995 5.84852 8.77814 4.60059 11.2622L9.58809 15.1313C10.1658 13.3484 11.2882 11.7917 12.7974 10.6805C14.3065 9.56928 16.1263 8.95955 18.0003 8.9372Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3625 18.3431C32.3578 17.3906 32.2785 16.4399 32.1253 15.4997H18V21.1369H26.0878C25.9126 22.0458 25.5582 22.9108 25.0452 23.6813C24.5323 24.4518 23.871 25.1124 23.1 25.6247L27.9309 29.3747C29.397 27.9458 30.5485 26.2265 31.3116 24.3269C32.0747 22.4272 32.4327 20.3891 32.3625 18.3431Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58097 20.8688C9.26998 19.9441 9.1095 18.9755 9.10566 18C9.10642 17.0242 9.26699 16.0552 9.58097 15.1313L4.59347 11.2622C3.54453 13.3534 2.99886 15.6608 3 18.0003C3.00114 20.3398 3.54906 22.6467 4.60003 24.7369L9.58097 20.8688Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 33C21.653 33.1055 25.2074 31.8059 27.9309 29.3691L23.1 25.6191C21.937 26.3658 20.6189 26.8372 19.2461 26.9974C17.8733 27.1577 16.4821 27.0025 15.1783 26.5438C13.8746 26.085 12.6927 25.3348 11.7228 24.3502C10.7529 23.3656 10.0204 22.1727 9.58125 20.8622L4.59375 24.7312C5.84196 27.217 7.75676 29.3067 10.1242 30.7669C12.4916 32.2271 15.2185 33.0003 18 33Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_2287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.2b0e042a8044abafea02cc4298c0e024.svg";
export { ForwardRef as ReactComponent };